/**
 * .tuMetrics {"tu1": 0.9, "tu2": 0.92, "tu3": 2, "notes": "Next occurrence for recurring cards", "tuVersion": "2.5"}
 * .help "Advances a recurring card's next date by daily/weekly/monthly, then skips past occurrences."
 */
import {
  addDays,
  addWeeks,
  addMonths,
  setHours,
  setMinutes,
  setSeconds,
  setMilliseconds,
  startOfDay,
  isPast,
} from 'date-fns';

export type RecurrenceFrequency = 'daily' | 'weekly' | 'monthly';

export type RecurrencePattern = {
  frequency?: RecurrenceFrequency | string;
  time?: string;
};

export function calculateNextOccurrenceDate(
  baseDate: Date,
  pattern: RecurrencePattern | Record<string, unknown> | undefined | null,
): string {
  const frequency = typeof pattern?.frequency === 'string' ? pattern.frequency : undefined;
  const time = typeof pattern?.time === 'string' ? pattern.time : undefined;
  let nextDate = startOfDay(baseDate);

  switch (frequency) {
    case 'daily':
      nextDate = addDays(nextDate, 1);
      break;
    case 'weekly':
      nextDate = addWeeks(nextDate, 1);
      break;
    case 'monthly':
      nextDate = addMonths(nextDate, 1);
      break;
    default:
      nextDate = addDays(nextDate, 1);
      break;
  }

  if (time && typeof time === 'string') {
    const [hours, minutes] = time.split(':').map(Number);
    nextDate = setHours(nextDate, hours);
    nextDate = setMinutes(nextDate, minutes);
    nextDate = setSeconds(nextDate, 0);
    nextDate = setMilliseconds(nextDate, 0);
  } else {
    nextDate = setHours(nextDate, 9);
    nextDate = setMinutes(nextDate, 0);
    nextDate = setSeconds(nextDate, 0);
    nextDate = setMilliseconds(nextDate, 0);
  }

  const now = new Date();
  let newNextOccurrenceDate = nextDate;
  while (isPast(newNextOccurrenceDate) && newNextOccurrenceDate.toDateString() !== now.toDateString()) {
    switch (frequency) {
      case 'daily':
        newNextOccurrenceDate = addDays(newNextOccurrenceDate, 1);
        break;
      case 'weekly':
        newNextOccurrenceDate = addWeeks(newNextOccurrenceDate, 1);
        break;
      case 'monthly':
        newNextOccurrenceDate = addMonths(newNextOccurrenceDate, 1);
        break;
      default:
        newNextOccurrenceDate = addDays(newNextOccurrenceDate, 1);
        break;
    }
  }

  return newNextOccurrenceDate.toISOString();
}
